module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/blog/super-sized-shipping/super-sized-shipping.component.scss
// module id = 771
// module chunks = 0